class JadePawImageCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.previousButton = this.querySelector('[data-carousel-previous]');
    this.nextButton = this.querySelector('[data-carousel-next]');
    this.controls = this.querySelector('.jp-image-carousel__controls');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.handlePrevious = () => this.scroll(-1);
    this.handleNext = () => this.scroll(1);
    this.handleScroll = () => window.requestAnimationFrame(() => this.updateControls());

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.updateControls());
    this.resizeObserver.observe(this.track);
    this.updateControls();
  }

  disconnectedCallback() {
    this.previousButton?.removeEventListener('click', this.handlePrevious);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.handleScroll);
    this.resizeObserver?.disconnect();
  }

  scroll(direction) {
    const card = this.track.querySelector('.jp-image-carousel__card');
    if (!card) return;

    const styles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const amount = card.getBoundingClientRect().width + gap;
    this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  updateControls() {
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const hasOverflow = maximum > 2;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= maximum - 2;

    if (this.controls) this.controls.hidden = !hasOverflow;
    this.previousButton.disabled = atStart;
    this.nextButton.disabled = atEnd;
  }
}

if (!customElements.get('jade-paw-image-carousel')) {
  customElements.define('jade-paw-image-carousel', JadePawImageCarousel);
}
